(function () {
	'use strict';

	var formonlineApp = angular.module('formonlineApp');

	formonlineApp.controller('MainController', function ($scope, $stateParams, Principal, $log, SidebarService, $http) {
		Principal.identity().then(function (account) {
			$scope.account = account;
			$scope.isAuthenticated = Principal.isAuthenticated;
			$scope.$watch($scope.isAuthenticated, function (isAuthenticated) {
				if (isAuthenticated) {
					Principal.identity().then(function (param) {
						$scope.account = param;
					});
				} else {
					$scope.account = null;
				}
			});
			$log.debug('account', account);
		});

		$scope.clearSideBarMenu = function () {
			//on vide le menu
			SidebarService.delAllMenus();
		};

	});

})();
